
<table class="w-full border-separate border-spacing-0 table-auto [&_th]:!border-[#EDE9E3] [&_td]:!border-[#EDE9E3]">
  <thead>
    <tr>
      <th/>
      <th
        colspan="3"
        class="!p-2 !text-center !align-middle text-[1rem] leading-[1rem] bg-[#F9F8F6] !font-medium border rounded-t-lg"
      >
        Exterior
      </th>
      <th/>
      <th
        colspan="3"
        class="!p-2 !text-center !align-middle text-[1rem] leading-[1rem] bg-[#F9F8F6] !font-medium border rounded-t-lg"
      >
        Interior
      </th>
      <th/>
      <th
        colspan="2"
        class="!p-2 !text-center !align-middle text-[1rem] leading-[1rem] bg-[#F9F8F6] !font-medium border rounded-t-lg"
      >
        Door Opening
      </th>
    </tr>
    <tr class="[&_th]:!p-2 [&_th]:!text-center [&_th]:!align-middle [&_th]:text-[0.75rem] [&_th]:leading-[0.75rem] [&_th]:!font-medium">
      <th/>
      <th class="border-x border-b bg-[#EEF4FF] text-[#3565FC]">L</th>
      <th class="border-b bg-[#F7FEE7] text-[#84CC16]">W</th>
      <th class="border-x border-b bg-[#F0FDFA] text-[#14B8A6]">H</th>
      <th class="p-0"/>
      <th class="border-x border-b bg-[#EEF4FF] text-[#3565FC]">L</th>
      <th class="border-b bg-[#F7FEE7] text-[#84CC16]">W</th>
      <th class="border-x border-b bg-[#F0FDFA] text-[#14B8A6]">H</th>
      <th class="p-0"/>
      <th class="border-x border-b bg-[#F7FEE7] text-[#84CC16]">W</th>
      <th class="border-r border-b bg-[#F0FDFA] text-[#14B8A6]">H</th>
    </tr>
  </thead>
  <tbody>
    <tr
      v-for="(containerTypeSize, index) in containerTypesSizes"
      :key="containerTypeSize.name"
      class="odd:bg-[#F9F8F6] [&_td]:!p-2 [&_td]:text-[1rem] [&_td]:leading-[1.5rem]"
    >
      <td class="!font-medium border-t">{{ containerTypeSize.name }}</td>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-bl-lg border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.exterior.length }}
      </td>
      <td
        class="border-t !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.exterior.width }}
      </td>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-br-lg border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.exterior.height }}
      </td>
      <td class="!p-0"/>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-bl-lg border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.interior.length }}
      </td>
      <td
        class="border-t !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.interior.width }}
      </td>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-br-lg border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.interior.height }}
      </td>
      <td class="!p-0"/>
      <td
        class="border-t border-x !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-bl-lg border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.doorOpening.width }}
      </td>
      <td
        class="border-t border-r !text-center !min-w-[5.5rem]"
        :class="[
          { '!border-t-0': index === 0 },
          { 'rounded-br-lg border-b': index === containerTypesSizes.length - 1 }
        ]"
      >
        {{ containerTypeSize.doorOpening.height }}
      </td>
    </tr>
  </tbody>
</table>
